/**
 * Pure helpers for BarChart.vue's PNG export: what caption text gets drawn
 * onto the downloaded image, and what the file gets named. Kept outside the
 * component so they're testable without mounting Chart.js/canvas.
 */

export function sanitizeFilenamePart(part: unknown): string {
  return String(part).replace(/[\\/:*?"<>|]/g, '').trim()
}

/**
 * Project name is always shown when known; the measure (action) name only
 * appears when given (i.e. only from Action-preview call sites) — the chart's
 * own title is already rendered inside the canvas by Chart.js, so it isn't
 * repeated.
 */
export function buildCaptionLines(projectName?: string, actionName?: string): string[] {
  return [
    projectName ? `Projekt: ${projectName}` : null,
    actionName ? `Maßnahme: ${actionName}` : null,
  ].filter((line): line is string => Boolean(line))
}

export function buildExportFilename(
  titleText?: string,
  projectName?: string,
  actionName?: string,
  filenameOverride?: string,
): string {
  if (filenameOverride) return filenameOverride
  const parts = [titleText, projectName, actionName]
    .filter(Boolean)
    .map(sanitizeFilenamePart)
    .filter(Boolean)
  return parts.length ? `${parts.join(' - ')}.png` : 'chart.png'
}
